import bannerPlaceholder from '@/assets/barbershop-hero.jpg';
import profilePlaceholder from '@/assets/barbershop-2.jpg';

export const COMPANY_BANNER_PLACEHOLDER = bannerPlaceholder;
export const COMPANY_PROFILE_PLACEHOLDER = profilePlaceholder;

export const resolveCompanyBanner = (image?: string | null) => image?.trim() || COMPANY_BANNER_PLACEHOLDER;

export const resolveCompanyProfile = (image?: string | null) => image?.trim() || COMPANY_PROFILE_PLACEHOLDER;
